import { render } from "./MinhaSenha.vue?vue&type=template&id=33cf0a0e"
import script from "./MinhaSenha.vue?vue&type=script&lang=js"
export * from "./MinhaSenha.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__